import { render } from "./DSelect.vue?vue&type=template&id=22d5fb5f&lang=pug"
import script from "./DSelect.vue?vue&type=script&lang=js"
export * from "./DSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__